import React, { Component } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Mint from "./Pages/Mint";

function App() {

	return (
		<div>
			<BrowserRouter>
				<Routes>

					<Route path='/' element={<Mint />} />
 
				</Routes>
			</BrowserRouter>
			<div>
		

			</div>
		</div>




	)
}


export default App;
